import React, { useEffect, useState } from 'react'
import {
  number, string,
} from 'prop-types'
import I18nMessage from '../../common/I18nMessage'
import EmailUpdatedSvg from './email-updated.svg'
import './EmailChangedSuccessfully.scss'

function EmailChangedSuccessfully({ countDownNumber: passedCountDownNumber, loginSrc }) {
  const [countDownNumber, setCountDownNumber] = useState()
  useEffect(() => {
    let count = passedCountDownNumber
    setCountDownNumber(count)
    const timer = setInterval(() => {
      count--
      if (count > 0) {
        setCountDownNumber(count)
      } else {
        clearInterval(timer)
        window.location = loginSrc
      }
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  }, [passedCountDownNumber, loginSrc])
  return (
    <div className="email-changed-successfully">
      <div className="successful-icon">
        <img
          src={EmailUpdatedSvg}
          alt="email-chanded-successfully"
        />
      </div>
      <div className="successful-title">
        <I18nMessage id="passport.updateAccount.result.title" />
      </div>
      <div className="successful-count-down-tip">
        <I18nMessage id="passport.updateAccount.result.description.countDown.tip" params={{ 0: countDownNumber }} />
      </div>
      <div className="successful-logIn-tip">
        <I18nMessage id="passport.updateAccount.result.description.logIn.tip" />
      </div>
      <div className="reFresh-tip-container">
        <a
          tabIndex={0}
          href={loginSrc}
          className="reFresh-link"
        >
          <I18nMessage id="passport.common.text.clickHere" />
        </a>
        <I18nMessage id="passport.updateAccount.result.description.reFresh.tip" />
      </div>
    </div>
  )
}

EmailChangedSuccessfully.propTypes = {
  countDownNumber: number.isRequired,
  loginSrc: string,
}

EmailChangedSuccessfully.defaultProps = {
  loginSrc: '',
}

export default EmailChangedSuccessfully
